
import { DisablableOption, ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";
import { AbilityScoreType } from "@dndModels/Types";

/**
 * Simple, Martial, Range, Ammunition, 
 * Finesse, Heavy, Light, 
 * Loading, Reach, Special, Thrown, 
 * Two-Handed, Versatile, Silvered, 
 * Monk, Hex-weapon, Armorer-weapon.
 */
export interface WeaponKeyword extends ModelBase {
  data_type: "weapon_keyword";
  _id: string;
  name: string;
  description: string;
  use_ability_score: AbilityScoreType | "Default"; // = "Default"; // If not "" then use that instead of STR
  alternate_ability_score: AbilityScoreType | "None"; // = "None"; // If not "" then use the higher one
  display_in_equipment: boolean; // = false;

  // constructor(obj?: any) {
  //   super(obj);
  //   if (obj) {
  //     this.use_ability_score = obj.use_ability_score ? obj.use_ability_score : "Default";
  //     if (!ABILITY_SCORES.includes(this.use_ability_score)) {
  //       this.use_ability_score = "Default";
  //     }
  //     this.alternate_ability_score = obj.alternate_ability_score ? obj.alternate_ability_score : "None";
  //     if (!ABILITY_SCORES.includes(this.alternate_ability_score)) {
  //       this.alternate_ability_score = "None";
  //     }
  //     this.display_in_equipment = obj.display_in_equipment ? obj.display_in_equipment : false;
  //   }
  // }

  // toDBObj(): any {
  //   const base_db_obj = super.toDBObj();
  //   return {
  //     ...base_db_obj,
  //     use_ability_score: this.use_ability_score,
  //     alternate_ability_score: this.alternate_ability_score,
  //     display_in_equipment: this.display_in_equipment,
  //   };
  // }

  // copy(copyMe: WeaponKeyword, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  //   this.use_ability_score = copyMe.use_ability_score;
  //   this.alternate_ability_score = copyMe.alternate_ability_score;
  //   this.display_in_equipment = copyMe.display_in_equipment;
  // }

  // clone(drop_ids: boolean = false): WeaponKeyword {
  //   const new_obj = new WeaponKeyword();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }
}

export const WEAPON_KEYWORDS: WeaponKeyword[] =
  [{
    data_type: "weapon_keyword",
    _id: "5fd124847a9c0d15f0a87834",
    name: "Martial",
    description: "This is a property added to a large set of weapons and is used as a Proficiency.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Martial",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd124c57a9c0d15f0a87835",
    name: "Monk",
    description: "This means it's usable by a monk.",
    use_ability_score: "Default",
    alternate_ability_score: "DEX",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Monk",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd125547a9c0d15f0a87836",
    name: "Finesse",
    description: "When making an attack with a finesse weapon, you use your choice of your Strength or Dexterity modifier for the attack and damage rolls. You must use the same modifier for both rolls.",
    use_ability_score: "STR",
    alternate_ability_score: "DEX",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Finesse",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd125c87a9c0d15f0a87837",
    name: "Range",
    description: "A weapon that can be used to make a ranged attack has a range shown in parentheses after the ammunition or thrown property. The range lists two numbers. The first is the weapon's normal range in feet, and the second indicates the weapon's long range. When attacking a target beyond normal range, you have disadvantage on the attack roll. You can't attack a target beyond the weapon's long range.",
    use_ability_score: "DEX",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Range",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd129737a9c0d15f0a87838",
    name: "Loading",
    description: "Because of the time required to load this weapon, you can fire only one piece of ammunition from it when you use an action, bonus action, or reaction to fire it, regardless of the number of attacks you can normally make.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Loading",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12c457a9c0d15f0a87839",
    name: "Ammunition",
    description: "You can use a weapon that has the ammunition property to make a ranged attack only if you have ammunition to fire from the weapon. Each time you attack with the weapon, you expend one piece of ammunition. Drawing the ammunition from a quiver, case, or other container is part of the attack (you need a free hand to load a one-handed weapon). At the end of the battle, you can recover half your expended ammunition by taking a minute to search the battlefield.\n\nIf you use a weapon that has the ammunition property to make a melee attack, you treat the weapon as an improvised weapon (see \"Improvised Weapons\" later in the section). A sling must be loaded to deal any damage when used in this way.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Ammunition",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12c727a9c0d15f0a8783a",
    name: "Heavy",
    description: "Creatures with a Strength score below 13 have disadvantage on Attack Rolls with heavy weapons.\n\nLegacy: Creatures that are Small or Tiny have disadvantage on attack rolls with heavy weapons. A heavy weapon's size and bulk make it too large for a Small or Tiny creature to use effectively.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Heavy",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12ca47a9c0d15f0a8783b",
    name: "Light",
    description: "A light weapon is small and easy to handle, making it ideal for use when fighting with two weapons.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Light",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12cd67a9c0d15f0a8783c",
    name: "Reach",
    description: "This weapon adds 5 feet to your reach when you attack with it, as well as when determining your reach for opportunity attacks with it.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Reach",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12d007a9c0d15f0a8783d",
    name: "Thrown",
    description: "If a weapon has the thrown property, you can throw the weapon to make a ranged attack. If the weapon is a melee weapon, you use the same ability modifier for that attack roll and damage roll that you would use for a melee attack with the weapon. For example, if you throw a handaxe, you use your Strength, but if you throw a dagger, you can use either your Strength or your Dexterity, since the dagger has the finesse property.",
    use_ability_score: "STR",
    alternate_ability_score: "DEX",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Thrown",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12d1e7a9c0d15f0a8783e",
    name: "Two-Handed",
    description: "This weapon requires two hands when you attack with it.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Two-Handed",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12d3e7a9c0d15f0a8783f",
    name: "Versatile",
    description: "This weapon can be used with one or two hands. A damage value in parentheses appears with the property - the damage when the weapon is used with two hands to make a melee attack.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Versatile",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "5fd12dcf7a9c0d15f0a87840",
    name: "Simple",
    description: "This is a property added to a large set of weapons and is used as a Proficiency.",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Simple",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "6013981a0e8a9022785da7be",
    name: "Simple Melee",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Simple Melee",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "601398270e8a9022785da7bf",
    name: "Martial Melee",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Martial Melee",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "601398270e8a9022785da7bf2",
    name: "Light Martial Melee",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Light Martial Melee",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "601398370e8a9022785da7c0",
    name: "Simple Ranged",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Simple Ranged",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "6013984d0e8a9022785da7c1",
    name: "Martial Ranged",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Martial Ranged",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "602ec59f67fae10560ff3a4c",
    name: "Melee",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: true,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Melee",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec2c4c327a01d582f6bff",
    name: "Sword",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Sword",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec2cdc327a01d582f6c00",
    name: "Axe",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Axe",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec2d4c327a01d582f6c01",
    name: "Bow",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Bow",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec2f5c327a01d582f6c02",
    name: "Polearm",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Polearm",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec43ac327a01d582f6c03",
    name: "Crossbow",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Crossbow",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ec57fc327a01d582f6c04",
    name: "Club",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Club",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "611ecb0bc327a01d582f6c05",
    name: "Hammer",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Hammer",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "62f513d9d4025e0009df1032",
    name: "Firearm",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Firearm",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "651f13ed3d25c4ed20f6abec",
    name: "Quarterstaff",
    description: "",
    use_ability_score: "Default",
    alternate_ability_score: "None",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Quarterstaff",
    tag_string: "", free: false
  }, {
    data_type: "weapon_keyword",
    _id: "664d4c3a051a211f35adfb83",
    name: "Kensei",
    description: "These are for the Path of the Kensei, and get applied to the character's chosen Weapon Types.",
    use_ability_score: "Default",
    alternate_ability_score: "DEX",
    display_in_equipment: false,
    image_url: "",
    archived: false, linkifiedName: "", linkURL: "",
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true,
    getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    // non_version_variant: false,
    // use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    // variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    tag_string: "", free: false,
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    description_format: "",
    // detail_format: "",
    display_format: "Kensei"
  }
];

export const WEAPON_KEYWORD_OPTIONS = WEAPON_KEYWORDS.map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});

export const WEAPON_KEYWORD_OPTIONS_DISPLAY = WEAPON_KEYWORDS.filter(o => o.display_in_equipment).map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});